import { Component, Input, OnInit } from '@angular/core';

@Component({
  templateUrl: './import-view.component.html',
  styleUrls: ['./import-view.component.scss']
})
export class ImportViewComponent {

  initialized = false;

}
